import { computed, ref, watch } from "vue";
import { GlobalSearchSort } from "@/graphql";
import {
  defaultGlobalSearchTypes,
  isGlobalSearchUIType,
  type GlobalSearchUIType,
} from "./GlobalSearchTypes";

const storageKey = "global-search-v2-preferences";

type StoredPreferences = {
  selectedTypes?: GlobalSearchUIType[];
  includeArchived?: boolean;
  siteId?: number;
  sort?: GlobalSearchSort;
};

function loadPreferences(): StoredPreferences {
  try {
    return JSON.parse(sessionStorage.getItem(storageKey) ?? "{}") as StoredPreferences;
  } catch {
    return {};
  }
}

const stored = loadPreferences();
const selectedTypes = ref<GlobalSearchUIType[]>(
  stored.selectedTypes?.filter(isGlobalSearchUIType) ?? [...defaultGlobalSearchTypes],
);
const includeArchived = ref(stored.includeArchived ?? true);
const siteId = ref<number | undefined>(stored.siteId);
const sort = ref<GlobalSearchSort>(stored.sort ?? GlobalSearchSort.RELEVANCE);
const siteIds = computed(() =>
  siteId.value == null || !Number.isInteger(siteId.value) ? [] : [siteId.value],
);

watch(
  [selectedTypes, includeArchived, siteId, sort],
  () => {
    sessionStorage.setItem(
      storageKey,
      JSON.stringify({
        selectedTypes: selectedTypes.value,
        includeArchived: includeArchived.value,
        siteId: siteId.value,
        sort: sort.value,
      } satisfies StoredPreferences),
    );
  },
  { deep: true },
);

export function useGlobalSearchPreferences() {
  return { selectedTypes, includeArchived, siteId, siteIds, sort };
}
